var exports = {
  "T": "x7be19a29--f5f498--map",
};

module.exports = exports;
